<template>
  <div class="ListApproveAccount">
    <HeaderPage>
    </HeaderPage>
    <el-card v-loading="loadingPage">
      <FilterBoxAppAccou v-on:filter="listDados" :currentPage="listData.meta ? listData.meta.pagination.current_page : 1" />
      <TableSimple :list-data="listData" @paginationClick="paginationClick">
        <el-table-column prop="data.name" label="Nome" />
        <el-table-column prop="description" label="Mensagem" />
        <el-table-column prop="status" label="Status">
          <template slot-scope="scope">
            <tagStatus :status="scope.row.status" />
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="Criado em" width="130">
          <template slot-scope="scope">
            {{moment(scope.row.created_at).format('DD/MM/YY HH:mm')}}
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="Atualizado em" width="130">
          <template slot-scope="scope">
            {{moment(scope.row.updated_at).format('DD/MM/YY HH:mm')}}
          </template>
        </el-table-column>
        <el-table-column width="55">
          <template slot-scope="scope">
            <el-button v-if="!$can('2|4|5')" type="text" @click="() => {$router.push({name: 'records.approveAccount.view', params: { id: scope.row.id }})}">
              <SearchIcon size="1.2x" style="padding: 0 7px;"></SearchIcon>
            </el-button>
          </template>
        </el-table-column>
      </TableSimple>
    </el-card>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import TableSimple from "@/app/components/Table/TableSimple";
import {SearchIcon} from "vue-feather-icons";
import {getAprovarContas} from "@/app/domains/Records/services";
import tagStatus from "@/app/components/Table/TagStatus";
import FilterBoxAppAccou from "@/app/domains/ApproveAccount/components/FilterBoxAppAccou";
import {makeErrorFilds} from "@/app/plugins/utils";

export default {
  name: "ListApproveAccount",
  components: {
    HeaderPage,
    TableSimple,
    tagStatus,
    SearchIcon,
    FilterBoxAppAccou,
    // FilterBox,
  },
  data () {
    return {
      loadingPage: false,
      listData: {}
    }
  },

  methods: {
    init () {
      this.listDados()
    },
    paginationClick (arg) {
      this.listDados('?page='+arg.page)
    },
    async listDados (query = '') {
      this.loadingPage = true
      this.error = {}
      try {
        let response = await getAprovarContas(query)
        this.listData = response.data
      } catch (e) {
        
        this.error = makeErrorFilds(e)
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>

</style>
